<template>
  <div class="mb-3">
    <matter-list />
    <!-- References tab: commented out for now, pending backend support for referred_by
    <b-tabs
      v-model="tabIndex"
      pills
    >
      <b-tab
        title="Matters"
        lazy
      >
        <matter-list />
      </b-tab>
      <b-tab
        title="References"
        lazy
      >
        <matter-list referred-by-only />
      </b-tab>
    </b-tabs>
    -->
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BButton,
  BRow,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormInput,
} from 'bootstrap-vue'
import MatterList from './matter-list/MatterList.vue'

export default {
  components: {
    MatterList,
    BTabs,
    BTab,
    BButton,
    BRow,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormInput,
  },
  // data() {
  //   return {
  //     tabIndex: this.$route.query.tab === 'references' ? 1 : 0,
  //   }
  // },
  // watch: {
  //   '$route.query.tab': function (tab) {
  //     this.tabIndex = tab === 'references' ? 1 : 0
  //   },
  // },
}
</script>
